import React from 'react'
import { CheckSquare, Bug, Bookmark, Zap, CornerDownRight } from 'lucide-react'
import { cn } from '@/lib/utils'

const iconMap = {
  'check-square': CheckSquare,
  'bug': Bug,
  'bookmark': Bookmark,
  'zap': Zap,
  'corner-down-right': CornerDownRight,
}

const TaskTypeIcon = ({ type, size = 'sm', className }) => {
  if (!type) return null

  const Icon = iconMap[type.icon] || CheckSquare
  const sizeClass = size === 'md' ? 'h-4 w-4' : 'h-3.5 w-3.5'

  return (
    <Icon
      className={cn(sizeClass, className)}
      style={{ color: type.color }}
    />
  )
}

export default TaskTypeIcon
